import { EntityService } from 'utils/entityService';

import { ListResponseModel } from 'models';
import request, { Methods } from 'utils/request';
import { UserSettingsModel } from 'models/userSettings.model';
import { RouteNames } from 'config/routeNames';
import { Mock } from 'utils/mockDecorator';

class UserSettingsService extends EntityService {
  constructor() {
    super('user-settings');
  }

  @Mock(() => import('mock/userSettings').then((m) => m.getMockUserSettings()))
  async getUserSettingsList() {
    return request<UserSettingsModel[]>({
      method: Methods.GET,
      resource: this.resource,
    });
  }

  async getUserSettingsById(id?: number | null) {
    return request<ListResponseModel<UserSettingsModel>>({
      method: Methods.GET,
      resource: `${this.resource}/${id}`,
    });
  }

  async getUserSettingsByScope(scope?: RouteNames) {
    return request<ListResponseModel<UserSettingsModel>>({
      method: Methods.GET,
      resource: `${this.resource}/${scope}`,
    });
  }

  @Mock((data: Partial<UserSettingsModel>) =>
    import('mock/userSettings').then((m) => m.createMockUserSettings(data))
  )
  async createUserSettings(data: Partial<UserSettingsModel>) {
    return request<UserSettingsModel>({
      method: Methods.POST,
      resource: this.resource,
      data,
    });
  }

  @Mock((id: ID, data: Partial<UserSettingsModel>) =>
    import('mock/userSettings').then((m) => m.updateMockUserSettings(id, data))
  )
  async editUserSettings(id: ID, data: Partial<UserSettingsModel>) {
    return request<UserSettingsModel>({
      method: Methods.PATCH,
      resource: `${this.resource}/${id}`,
      data,
    });
  }

  @Mock((id: ID) =>
    import('mock/userSettings').then((m) => {
      m.deleteMockUserSettings(id);
    })
  )
  async deleteUserSettings(id: ID) {
    return request({
      method: Methods.DELETE,
      resource: `${this.resource}/${id}`,
    });
  }
}

export const userSettingsService = new UserSettingsService();
